import facebookPixelConfig from "./config/facebook-pixel";

const noop = () => {};

function loadTrackingScript({ init = noop, onload = noop, preload = noop, src = "" }) {
  if (!src) {
    throw new ReferenceError("Script source not provided");
  }

  init();
  preload();

  const [node] = document.getElementsByTagName("script");
  const script = document.createElement("script");

  script.async = true;
  script.src = src;
  script.addEventListener("load", onload);
  node.parentNode.insertBefore(script, node);
}

function facebookPixel() {
  loadTrackingScript(facebookPixelConfig); // dogfooding
}

export default {
  facebookPixel,
  loadTrackingScript
};



// WEBPACK FOOTER //
// ./components/remarketing/remarketing.js